import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { NeoBadge } from "../../../../../../components/Common";
import EnrollmentService from "../../../../../../services/enrollment";
import { formatDate } from "../../../../../../utils/date";

const ActionUsageDetails = ({ membership, idTenant }) => {
    const [loading, setLoading] = useState(false);
    const [enrollments, setEnrollments] = useState([]);

    useEffect(() => {
        const fetchUsage = async () => {
            if (!membership?.id || !idTenant) return;
            setLoading(true);
            try {
                // Pega todas matrículas do membro e filtra as que correspondem a este pacote
                const memberEnrollments = await EnrollmentService.listMemberEnrollments(idTenant, membership.idMember);
                const packageEnrollments = memberEnrollments.filter(e => e.idMembership === membership.id && e.type === "class-package");
                
                // Ordena por data mais recente
                packageEnrollments.sort((a, b) => new Date(b.sessionDate) - new Date(a.sessionDate));
                setEnrollments(packageEnrollments);
            } catch (error) {
                console.error("Erro ao buscar histórico de uso:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUsage();
    }, [membership, idTenant]);

    if (loading) {
        return (
            <div className="text-center p-4 font-size-13 text-muted" style={{ fontFamily: 'Outfit, sans-serif' }}>
                <i className="mdi mdi-loading mdi-spin me-2 fs-5"></i>Carregando histórico...
            </div>
        );
    }

    if (enrollments.length === 0) {
        return (
            <div className="p-4 text-center border mt-3 bg-white shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(0, 0, 0, 0.06)', fontFamily: 'Outfit, sans-serif' }}>
                <i className="mdi mdi-text-box-remove-outline font-size-24 text-muted mb-2 d-block"></i>
                <p className="text-muted mb-0">Nenhuma aula consumida até o momento.</p>
            </div>
        );
    }

    return (
        <div className="p-4 border mt-3 bg-white shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(0, 0, 0, 0.06)', fontFamily: 'Outfit, sans-serif' }}>
            <h6 className="fw-bold mb-3 font-size-14 text-uppercase" style={{ letterSpacing: "0.5px", color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                <i className="mdi mdi-history me-1" style={{ color: 'var(--color-brand-secondary)' }}></i>Histórico do Pacote
            </h6>
            <div className="table-responsive bg-white border p-2 shadow-sm" style={{ maxHeight: "300px", overflowY: "auto", borderRadius: '12px', borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                <Table size="sm" className="table-borderless table-nowrap align-middle mb-0 font-size-12" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    <thead className="table-light text-muted">
                        <tr>
                            <th className="fw-bold font-size-11 text-uppercase" style={{ width: "120px", letterSpacing: '0.5px' }}>Data</th>
                            <th className="fw-bold font-size-11 text-uppercase" style={{ letterSpacing: '0.5px' }}>Turma / Modalidade</th>
                            <th className="fw-bold font-size-11 text-uppercase text-center" style={{ width: "100px", letterSpacing: '0.5px' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {enrollments.map((e, idx) => {
                            const isCanceled = e.status === "canceled";
                            return (
                                <tr key={e.id || idx} className="border-bottom">
                                    <td className={isCanceled ? "text-muted" : "fw-bold"}>
                                        {formatDate(e.sessionDate)}
                                    </td>
                                    <td>
                                        <div className={isCanceled ? "text-muted" : "text-dark fw-bold"}>
                                            {e.activityName || 'Atividade'}
                                        </div>
                                        <div className="font-size-11 text-muted">
                                            {e.weekdayLabel} {e.startTime && e.endTime ? `${e.startTime} às ${e.endTime}` : ''}
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <NeoBadge color={isCanceled ? "muted" : "success"} className="px-2 py-1">
                                            {isCanceled ? "Estornada" : "Confirmada"}
                                        </NeoBadge>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default ActionUsageDetails;
